import React from 'react';

export const FlexEnd = ({ children, style }) => (
  <div
    style={{
      ...style,
      display: 'flex',
      justifyContent: 'flex-end'
    }}
  >
    {children}
  </div>
);

export const Flex = ({ children, style }) => (
  <div
    style={{
      ...style,
      display: 'flex'
    }}
  >
    {children}
  </div>
);

export const FlexRow = ({ children, style }) => (
  <div
    style={{
      marginBottom: 20,
      display: 'flex',
      ...style
    }}
  >
    {children}
  </div>
);

export const FlexEndRow = ({ children, style }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      marginBottom: '20px',
      ...style
    }}
  >
    {children}
  </div>
);
